<script>
  import mixin from "../mixin";

  export default {
    name: "PartnerRegistered",
    mixins: [mixin],
  }
</script>

<template>
  <div class="d-flex align-items-center">
    <p
      class="p-base-medium text-neutral-400 m-b-9 cursor-pointer"
      @click="viewPartnerDetails()"
    >
      <span>{{ $t(`notifications.${notification.type}.newAccountRegistration`) }}</span>
      <span class="m-l-3 text-neutral-900">{{ partner.name }}</span>
    </p>
  </div>
</template>

<style lang="sass" scoped>

</style>
